import FormPassword from '../templates/FormPassword';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface PasswordConfirmProps {
  name?: string;
  label?: string;
  placeholder?: string;
  rules?: any;
  required?: boolean;
  password?: string;
}

const PasswordConfirm = ({
  name = 're-password',
  label = 'Confirm Password',
  placeholder = 'Enter confirm password',
  rules,
  password,
  required = true,
  ...props
}: PasswordConfirmProps): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useMemo(() => {
    const rulesState: any = [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const password = getFieldValue('password');
          if (!value || password === value) {
            return Promise.resolve();
          }

          return Promise.reject(new Error(t('Password does not match')));
        },
      }),
    ];

    if (required || password)
      rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, required, rules, password]);

  return <FormPassword rules={rulesMemo} {...{ name, label, placeholder, ...props }} />;
};

export default PasswordConfirm;
